import {graphql} from 'react-apollo';
import {removeUnitFromTripBoardsMutation} from '../../graphql';
import {readPreviewsCache, writePreviewsCache} from './with-fetch-previews';

export const removeListingFromCache = (listingId, hav, pageSize, listingPageSize) => {
    return (proxy) => {
        const cache = readPreviewsCache(proxy, hav, pageSize, listingPageSize);
        if (!cache || !cache.paginatedTripBoards) {
            return; // we aren't being fed a populated cache, why bother?
        }
        const boards = cache.paginatedTripBoards.tripBoards || [];
        for (let index = 0; index < boards.length; index++) {
            const tripboard = boards[index];
            const listingRefs = tripboard.listingRefs.filter((listing) => listing !== listingId);
            const listings = tripboard.listings.filter(({listingId: thisListingId}) => thisListingId !== listingId);
            tripboard.listingRefs = listingRefs;
            tripboard.listings = listings;
        }

        writePreviewsCache(proxy, hav, pageSize, listingPageSize, cache);
    };
};

export const optimisticRemoveListingFromTripBoardResponse = {
    removeUnitFromTripBoards: true
};

const withRemoveFromTripBoards = graphql(removeUnitFromTripBoardsMutation, {
    options: (props) => ({
        ...props.mutationConfig,
        optimisticResponse: optimisticRemoveListingFromTripBoardResponse
    }),
    name: 'removeFromTripBoards',
    alias: 'withRemoveFromTripBoardsMutation'
});

export default withRemoveFromTripBoards;
